import React, {Component, PropTypes} from 'react';
import uuid from "node-uuid";
import {Button, Col, Input, Row} from 'react-bootstrap';
import {ShareButtons} from 'react-share';
import {connect} from 'react-redux';
import {bindSessions, unbind} from 'actions/sessionActions';
import {generateUserReferral, loadUserReferral} from 'actions/referralActions';
import {getAvailableProgramsForProfile} from 'services/programs';
import isMobile from 'ismobilejs';
import copy from 'copy-to-clipboard';
import {intercomCreateLead} from "services/intercom";
import {publishEvent} from "services/events";
import {programLookup} from "../../../programs";
import messengerIcon from '../../images/facebook-messenger-white.svg';
import facebookIcon from '../../images/facebook.svg';
import twitterIcon from '../../images/twitter.svg';
import Goober from '../../images/Goober-open-jump-cutout.png';
import ShareIcon from '../../images/iconmonstr-share-3-240.png';
import CursorIcon from '../../images/iconmonstr-cursor-7-240.png';
import CheckboxIcon from '../../images/iconmonstr-checkbox-2-240.png';
import './invite.scss'

const {TwitterShareButton} = ShareButtons;

const FACEBOOK_APPID = 1670987266293612;

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const BlurbMap = {
  //"" = No program
  "": "The Planet Protector Academy by @enviroheroes is a fun and engaging teaching resource that inspired my students to become environmental superheroes! Use my referral link for access (worth $250)!",
  "keepCool": "The Planet Protector Academy: Keep Cool by @enviroheroes is a fun and engaging climate change teaching resource that inspired my students to become climate action superheroes! Use my referral link for access (worth $250)!",
  "zeroHeroes": "The Planet Protector Academy: Zero Heroes by @enviroheroes is a fun and engaging waste reduction teaching resource that inspired my students to become zero waste superheroes! Use my referral link for access (worth $250)!",
  "h2whoa": "The Planet Protector Academy: H2Whoa! by @enviroheroes is a fun and engaging water teaching resource that inspired my students to become water saving and protecting superheroes! Use my referral link for access (worth $250)!",
  "espPrimaries": "The Emergency Preparedness Squad by @enviroheroes is a fun and engaging teaching resource that inspired my students to become emergency preparedness superheroes! Use my referral link for access (worth $250)!",
  "espIntermediates": "The Emergency Preparedness Squad by @enviroheroes is a fun and engaging teaching resource that inspired my students to become emergency preparedness superheroes! Use my referral link for access (worth $250)!"
};

function buildReferralUrl(source, featuredProgram, referrerId) {
  const fp = featuredProgram ? `&fp=${featuredProgram}` : "";
  return `https://${window.location.host}/r?refId=${referrerId}${fp}`;
}

function buildMessengerUrl(isMobile, featuredProgram, referrerId) {
  const referralUrl = buildReferralUrl("messenger", featuredProgram, referrerId);
  const redirectUrl = `${window.location.href}?messenger=done`;
  if (isMobile) {
    return `fb-messenger://share?link=${encodeURIComponent(referralUrl)}&app_id=${FACEBOOK_APPID}`
  }
  return `https://www.facebook.com/dialog/send?app_id=${FACEBOOK_APPID}&link=${encodeURIComponent(referralUrl)}&redirect_uri=${encodeURIComponent(redirectUrl)}`;
}

function findFeaturedProgram(sessions) {
  let sessionList = sessions.sessionList.map(sessionId => {
    return sessions.sessions[sessionId];
  });
  sessionList.sort((a, b) => a.updatedAt - b.updatedAt);
  let lastSessionWithContract = sessionList.filter(session => session.funding === 'CONTRACT' && !programLookup[session.programId].featuredOnly)[0];
  if (lastSessionWithContract) {
    return lastSessionWithContract.programId;
  }
  return '';
}

function shareOnMessenger(link) {
  FB.ui({
    method: "send",
    link
  })
}

function shareOnFacebook(link, quote) {
  FB.ui({
    method: "share",
    href: link,
    quote
  })
}

export class Invite extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      authData: PropTypes.shape({
        uid: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    sessions: PropTypes.object.isRequired,
    bindSessions: PropTypes.func.isRequired,
    unbind: PropTypes.func.isRequired,
    userReferral: PropTypes.object.isRequired,
    loadUserReferral: PropTypes.func.isRequired,
    generateUserReferral: PropTypes.func.isRequired
  };

  static contextTypes = {
    profile: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      error: '',
      featuredProgram: '',
      emails: '',
      emailInviteSent: false
    };
  }

  componentDidMount() {
    const userId = this.props.auth.authData.uid;
    this.boundRefs = [];
    this.props.bindSessions(userId, this.boundRefs);
    this.props.loadUserReferral(userId);
  }

  componentWillUnmount() {
    this.props.unbind(this.boundRefs);
  }

  componentWillReceiveProps(props, ctx) {
    this.setState({featuredProgram: findFeaturedProgram(props.sessions)});
    if (props.userReferral.loaded && !props.userReferral.referrerId && !props.userReferral.generating) {
      const {firstName, lastName} = ctx.profile;
      const userId = this.props.auth.authData.uid;
      this.props.generateUserReferral(userId, firstName, lastName);
    }
  }

  shareOnMessenger() {
    shareOnMessenger(buildReferralUrl("messenger", this.state.featuredProgram, this.props.userReferral.referrerId));
  }

  shareOnFacebook(quote) {
    shareOnFacebook(buildReferralUrl("facebook", this.state.featuredProgram, this.props.userReferral.referrerId), quote);
  }

  inviteByIntercom(email, url, programId) {
    const {auth: {authData: {uid: referrerUserId}}} = this.props;
    const {
      firstName: referrerFirstName,
      lastName: referrerLastName
    } = this.context.profile;
    const inviteData = {
      referralId: uuid.v4(),
      referralSource: "email",
      referrerUserId,
      referrerFirstName,
      referrerLastName,
      referrerUniqueUrl: url,
      referredProgramId: programId
    };
    return intercomCreateLead({email, custom_attributes: inviteData})
      .then(leadId => {
        publishEvent('Referral Lead Created', { ...inviteData, referreeEmail: email, leadId });
      }, err => {
        console.log(`inviteByIntercom failed for ${email}`, err);
        throw new Error(`There was an issue sending an invite to ${email}. Please try again later.`);
      });
  }

  handleSendInvites(evt, referralUrl) {
    evt.preventDefault();
    const emails = this.state.emails.split('\n').map(x => x.trim()).filter(x => !!x)
      .reduce((acc,cur) => {
        const lineEmails = cur.split(',').map(x => x.trim()).filter(x => !!x);
        acc.push(...lineEmails);
        return acc;
      }, []);
    if (!emails.length) {
      this.setState({emailInviteSent: false, error: "You need to provide at least one email address."});
      return;
    }
    if (emails.length > 5) {
      this.setState({emailInviteSent: false, error: "Sorry, you can only send 5 invites at a time."});
      return;
    }
    const errors = emails
      .map((email) => {
        const m = email.match(emailRegex);
        if (!m) {
          return `${email} is not a valid email.`
        }
      })
      .filter(x => !!x);
    if (errors.length) {
      this.setState({emailInviteSent: false, error: errors.join(" ")});
      return;
    }
    const {featuredProgram} = this.state;
    const promises = [];
    for (const email of emails) {
      promises.push(this.inviteByIntercom(email, referralUrl, featuredProgram));
    }
    Promise.all(promises)
      .then(() => {
        this.setState({emailInviteSent: true, error: "", emails: ""});
      }, err => {
        this.setState({emailInviteSent: false, error: err.message})
      });
  }

  render() {
    const {profile, i18n: _} = this.context;
    const {featuredProgram} = this.state;

    const programs = getAvailableProgramsForProfile(profile).filter(x => !x.featuredOnly);
    const mobileLink = isMobile.phone || isMobile.tablet;
    const quote = BlurbMap[featuredProgram] || BlurbMap[""];
    const {userReferral} = this.props;
    const ready = userReferral.loaded && userReferral.referrerId;
    const referralUrl = ready ? buildReferralUrl("", featuredProgram, userReferral.referrerId) : "";

    if (!ready) {
      return <Row className="invite not-ready">
        <Col xs={12}>
          {!userReferral.loaded && <Row>Loading...</Row>}
          {!userReferral.referrerId && <Row>Generating unique referrer Id...</Row>}
          {userReferral.error && <Row>{userReferral.error}</Row>}
        </Col>
      </Row>
    }

    return <Row className="invite">
      <Col xs={12}>
        <Col xs={12} sm={12} className="invite-header">
          <Col xs={12} sm={6}>
            Invite a friend and share the fun!
          </Col>
          <Col xs={12} sm={6}>
            <img src={Goober} />
          </Col>
        </Col>
        <Col xs={12} sm={12} className="invite-howto">
          <Col xs={12} sm={4}>
            <Col xs={1} sm={2}><img src={ShareIcon} /></Col>
            <Col xs={11} sm={9}>You share your link with friends</Col>
          </Col>
          <Col xs={12} sm={4}>
            <Col xs={1} sm={2}><img src={CursorIcon} /></Col>
            <Col xs={11} sm={9}>Your friend signs up their class</Col>
          </Col>
          <Col xs={12} sm={4}>
            <Col xs={1} sm={2}><img src={CheckboxIcon} /></Col>
            <Col xs={11} sm={10}>You help increase our impact!</Col>
          </Col>
        </Col>
      </Col>
      <Col xs={12} className="invite-mixed">
        <Row className="invite-featuredProgram">
          <Col xs={12} sm={5}>
            Featured program<br/>
          </Col>
          <Col xs={12} sm={7}>
            <select className="form-control" value={featuredProgram}
                    onChange={evt => this.setState({featuredProgram: evt.target.value})}>
              <option key="none" value=""></option>
              {programs.map(x => <option key={x.id} value={x.id}>{_(x.longTitle)}</option>)}
            </select>
          </Col>
        </Row>
        <Row>
          <hr/>
        </Row>
        <Row className="invite-email">
          <Col xs={12}>
            Share by email
          </Col>
          <div className="error">{this.state.error}</div>
          {this.state.emailInviteSent && <div className="sent">
            <p>Your invite(s) have been sent.</p>
            <p>Don't forget to remind your colleagues next time you see them!</p>
          </div>}
          <Col xs={12} sm={8}>
              <textarea id="emails"
                        className="form-control"
                        placeholder="Enter up to 5 email addresses here. One per line..."
                        spellCheck="false"
                        rows={5}
                        onChange={evt => this.setState({emails: evt.target.value})}
                        value={this.state.emails}/>
          </Col>
          <Col xs={12} sm={4} className="invite-email-btn-container">
            <button type="submit" className="btn btn-lg btn-primary"
                    onClick={evt => this.handleSendInvites(evt, referralUrl)}>
              Send invites
            </button>
          </Col>
        </Row>
        <Row>
          <hr/>
        </Row>
        <Row className="invite-social">
          <Col xs={12}>
            Share on social media
          </Col>
          <Col xs={12} sm={4}>
            {mobileLink &&
            <a className="btn btn-sm messenger-share-btn"
               href={buildMessengerUrl(mobileLink, featuredProgram, userReferral.referrerId)}>
              <img src={messengerIcon}/>Messenger
            </a>
            }
            {!mobileLink &&
            <a className="btn btn-sm messenger-share-btn"
               onClick={() => this.shareOnMessenger()}>
              <img src={messengerIcon}/>Messenger
            </a>
            }
          </Col>
          <Col xs={12} sm={4}>
            <a className="btn btn-sm facebook-share-btn"
               onClick={() => this.shareOnFacebook(quote)}>
              <img src={facebookIcon}/>Facebook
            </a>
          </Col>
          <Col xs={12} sm={4}>
            <TwitterShareButton className="btn btn-sm twitter-share-btn"
                                url={buildReferralUrl("twitter", featuredProgram, userReferral.referrerId)}
                                title={quote}>
              <img src={twitterIcon}/>Twitter
            </TwitterShareButton>
          </Col>
        </Row>
        <Row>
          <hr/>
        </Row>
        <Row className="invite-diy">
          <Col xs={12}>
            Share your link
          </Col>
          <div className="col-xs-12">
            <div className="input-group input-group-sm">
              <Input type="text" readOnly="readOnly"
                     value={referralUrl}/>
              <div className="input-group-btn">
                <Button bsSize="small" title="Copy to clipboard" onClick={() => copy(referralUrl)}>
                  Copy
                </Button>
              </div>
            </div>
          </div>
        </Row>
      </Col>
    </Row>
  }

}

export default connect(
  state => ({
    auth: state.auth,
    sessions: state.sessions,
    userReferral: state.userReferral
  }), {
    bindSessions,
    unbind,
    loadUserReferral,
    generateUserReferral
  }
)(Invite);



// WEBPACK FOOTER //
// ./src/views/invite/invite.jsx